var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIconSVg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 13.999",
    opacity: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.947,7.26a.972.972,0,0,0-.774-.659l-3.654-.547L9.873,2.561a.96.96,0,0,0-1.747,0L6.5,6.04,2.827,6.6a.972.972,0,0,0-.774.659,1,1,0,0,0,.232,1.023l2.66,2.723-.628,3.838a.992.992,0,0,0,.405.979.945.945,0,0,0,1.01.057l3.244-1.812,3.29,1.812a.946.946,0,0,0,1.01-.057.991.991,0,0,0,.405-.979L13.053,11l2.661-2.718A1,1,0,0,0,15.947,7.26Z",
    transform: "translate(-1.999 -2)",
    fill: "currentColor",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconSVg);
export default __webpack_public_path__ + "static/media/starIconSVg.588e8a49c625388fa9592d2c85f1befc.svg";
export { ForwardRef as ReactComponent };